import cardlayer from './CardLayReducer.js';
import ioReducer from './IOReducer.js';
import { combineReducers } from 'redux';

export default combineReducers({ cardlayer, ioReducer });